import { Box } from "@material-ui/core";
import { withStyles } from "@material-ui/styles";
import { fontColor } from "../utils/configuration";
export default withStyles({
    root: {
        whiteSpace: "normal",
        wordBreak: "break-word",
        maxWidth: "100%",
        display: "flex",
        alignItems: "center",
        gap: "16px",
        fontSize: 12,
        fontWeight: 400,
        letterSpacing: "0.4px",
        cursor: "pointer",
        "& > span": { fontSize: 21, color: fontColor },
    },
})(Box);
